import { render, staticRenderFns } from "./ConfirmAddress.vue?vue&type=template&id=3fbcfdbe&scoped=true&"
import script from "./ConfirmAddress.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddress.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAddress.vue?vue&type=style&index=0&id=3fbcfdbe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbcfdbe",
  null
  
)

export default component.exports